import React, {useEffect} from "react";

type ModalProps = {
    open: boolean;
    closeHandler: Function;
}

const Modal: React.FC<ModalProps> = ({open, closeHandler, children}) => {
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "unset";
    }, [open])

    return (
        <div className={["search-box-modal", open ? "open" : ""].join(" ")}>
            <div className="search-box-modal-backdrop"
                 onClick={() => {
                     closeHandler && closeHandler();
                 }}>
            </div>
            <div className="search-box-modal-content">
                {open && children}
            </div>
        </div>
    );
};

export default Modal;